import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    align-items: center;
`;

export const Dot = styled.div`
    height: 12px;
    width: 12px;

    display: inline-block;
    margin-right: 4px;

    background: ${(props) => (props.active ? `var(--gray800)` : `var(--color-white)`)};

    border-radius: 100%;
    border: 1px solid var(--gray800);
    box-sizing: border-box;
`;

const Difficulty = ({ level = 0 }) => (
    <Container>
        <Dot active={level > 0} />
        <Dot active={level > 1} />
        <Dot active={level > 2} />
        <Dot active={level > 3} />
        <Dot active={level > 4} />
    </Container>
);

Difficulty.propTypes = {
    level: PropTypes.number,
};

export default Difficulty;
